__turbopack_context__.v({
  "amber": "navbar-module__Tyipbq__amber",
  "arrowDown": "navbar-module__Tyipbq__arrowDown",
  "closeButton": "navbar-module__Tyipbq__closeButton",
  "dark": "navbar-module__Tyipbq__dark",
  "isActive": "navbar-module__Tyipbq__isActive",
  "light": "navbar-module__Tyipbq__light",
  "link": "navbar-module__Tyipbq__link",
  "logo": "navbar-module__Tyipbq__logo",
  "mobileLogo": "navbar-module__Tyipbq__mobileLogo",
  "navButton": "navbar-module__Tyipbq__navButton",
  "navLink": "navbar-module__Tyipbq__navLink",
  "navbar": "navbar-module__Tyipbq__navbar",
  "navbarContent": "navbar-module__Tyipbq__navbarContent",
  "navbarMobile": "navbar-module__Tyipbq__navbarMobile",
  "transparent": "navbar-module__Tyipbq__transparent",
  "white": "navbar-module__Tyipbq__white",
});
